
const accreditationsSliders = document.querySelectorAll( '[data-slider="accreditations-slider"' );
accreditationsSliders.forEach( slider => {
    const options = {
        infinite: true,
        rows: 0,
        focusOnSelect: false,
        autoplay: true,
        autoplaySpeed: 1,
        speed: 4000,
        cssEase: 'linear',
        arrows: false,
        swipe: false,
    };

    if ( slider.dataset.sliderLayout == 'rows' ) {
        jQuery( slider ).slick( {
            ...options,
            slidesToShow: 8,
            centerMode: true,
            centerPadding: '0',
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 7,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        } );
    } else if ( slider.dataset.sliderLayout == 'columns' ) {
        jQuery( slider ).slick( {
            ...options,
            slidesToShow: 4,
            rows: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2,
                        rows: 1,
                        centerMode: true,
                    }
                },
            ]
        } );
    }
} );
